/**
 *
 * Asynchronously loads the component for AssetDetails
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AssetDetails = lazyLoad(
  () => import('./index'),
  module => module.AssetDetails,
);
